<template>
 <NavBarr v-if="route_name" />
<div :class="{flex:route_name} " >
 <router-view ref="abs"/> 
  <SideNav v-if="route_name" />
  </div>
</template>
<script setup>
import SideNav from '@/components/SideNav.vue'
import NavBarr from '@/components/NavBarr.vue'
import { ref,watchEffect } from 'vue';
import { useRouter } from 'vue-router'

  const router = useRouter()
  const route_name= ref(false)

  watchEffect(()=>{
   
    if(router.currentRoute.value.name == 'ComplainPrint'
    || 
    router.currentRoute.value.name == '_404'
     )
       route_name.value = false
    else
    route_name.value = true
  })

</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@500&display=swap');

#app {
font-family: 'Noto Sans Arabic', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.container{
    margin: 2rem
}
.input-in-con{
   display: flex;
    justify-content: flex-end;
  flex-wrap: wrap;
}
input,select{
    direction: rtl;
}
.input-in-con label{
  width: 100%;
    text-align: end;
}
.heading{
    text-align: end;
    margin-bottom: 2rem
}
.flex{
    display: flex
}
.half{
    width: 95%;
}
.last{
    justify-content: end
}
.last-50{
    width: 50%
}
.input-in-con {
  position: relative;
}

.input-in-con > p {
  position: absolute;
  top: 40px;
  right: 10px;
  max-width: 25px;
}
/* .input-in-con > input,.input-in-con > textarea {
padding: 0.5rem 2.6rem  
}*/

.nav-right{
  height: 100vh;
    background: #235aae !important;
    color: white !important;
    padding: 0.5rem;
}
.logo,.search{
    text-align: center;
    justify-content: center;
    margin-top: 1rem;
}
.search{
    margin: 1.3rem 0;
    outline: none;
    border-radius: 11px;
    border: none;
}
.pills{
    color: white;
}
.pill{
    display: flex;
    justify-content: space-between;
}
a.btn{
    width: 100%;
    direction: rtl;
}
a.btn,ul.dropdown-menu{
    background: none;
    border: none;
}
.dropdown-item{
    color: white
}
div.dropdown{
    width: 100%
}
.ltr{
  direction: ltr
}
.white{
  color: white !important
}
.text-right{
  text-align: right;
}

a{
  text-decoration: none;
}
.font-s{
  font-size: 1.2rem;
  border: none
}
.mb-1{
  margin-bottom: 1rem!important;
    border: 1px solid #9f9c9c;
    border-right: 0;
    border-left: 0;
    padding: 0.25rem;
    border-top: 0;
}
.p-0{
  padding: 0rem !important;
}
.li-nav{
  border-bottom: 1px solid #9f9c9c;
    padding-right: 2rem;
    padding-bottom: 0.5rem;
        padding-top: 0.5rem;
}
.border0{
  border: 0
}
.fleex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.arrow{
  margin: 0;
    padding-left: 1rem;
}
.icon{
  width: 1.8rem;
  margin-left: 0.50rem
}
.heading{
  font-weight: bold;
    font-size: 2rem;
}
.rtl{
    direction: rtl;
}
.star_fa{
  margin: 0;
    padding: 0 !important;
     position: inherit; 
}
.star{
  margin: 0;
  padding: 0; 
}
.navbar{
  direction: rtl;
}
.navbar-toggler{
  margin: 1rem
}
.show{
  text-align: right;
    padding: 0;
    margin: 0;
}.navbar{
  direction: rtl;
}
.navbar-toggler{
  margin: 1rem
}
.show{
  text-align: right;
    padding: 0;
    margin: 0;
}
.flex{
  justify-content: flex-end
}
.form-check{
  display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;

}
.form-check-input{
  margin-right: 0.75rem
}
.put-right{
  text-align: initial
}








nav{
  display: none!important;
}
.menu{
  text-align: center;
  margin-right: 0
}
.row-data{
    margin-top: 1rem;
    padding: 0.5rem 0;
}

.input-in-conn {
  position: relative;
}

.input-in-conn > img {
  position: absolute;
  top: 10px;
  right: -10px;
  max-width: 25px;
}
.col{
    padding: 0;
    margin: 0 0.2rem;
}
.right{
  display: flex;
  justify-content: center
}
.icon-small{
  width: 1rem;
}
.icon-button{
  border: none;
  border-radius: 4px;
    margin: 0 0.25rem ;
    display: flex;
    padding: 0.3rem;
}

.red{
  background: #b30000
}
.orange{
  background: #e59604;
}
.dropp{
  color: black!important
}
tbody tr{
  background: white;
box-shadow: -2px -3px 5px #888888;}

.green{
  border-bottom: 3px solid green !important;
}
.reed{
  border-bottom: 3px solid red;
}
.orangee{
    border-bottom: 3px solid orange;

}
.blur{
  background: aliceblue;
    width: 100%;
    height: 118%;
    opacity: 0.8;
    position: absolute;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mesa-con{
  width: 100%;
    position: absolute;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.squa{
  background: white;
    padding: 2rem 4rem;
    border-radius: 1.5rem;
    box-shadow: 1px 1px 10px 2px #888888;
}
.h3-t{
  text-align: center;
    font-weight: bold;
}
.ff{
  justify-content: space-around;
    margin-top: 2rem;
}
.bb{
  border: none;
    font-size: 1.4em;
    padding: 0 0.6rem;
    border-radius: 5px;
   
}
.dele{
 background: #c70e0e;
     color: white;
}
.canc{
 background: white;
     color: black;
     border: 1px solid black
}
.rtl{
  direction: rtl
}
 @media (max-width: 991.98px) {
  nav{
    display: inline!important

  }
  .nav-right{
    display: none
  }
  .hidee{
    display: none
  }
}
</style>
